// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"e5c991f1","194":"4faa92a9","239":"e39fb35b","455":"1b991356","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};